import React from 'react';
import { textPrimaryM } from 'web-ui-kit/colors';

function DeleteIcon(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 24 : _ref$width;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      width: width,
      viewBox: "0 0 24 24",
      fill: "none",
      "aria-label": "delete",
      role: "img",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M20.9999 3.16801H15.2159V1.89601C15.2159 1.17601 14.6399 0.600006 13.9199 0.600006H10.0799C9.35993 0.600006 8.78393 1.17601 8.78393 1.89601V3.19201H2.99993C2.63993 3.19201 2.35193 3.48001 2.35193 3.84001V7.05601C2.35193 7.41601 2.63993 7.70401 2.99993 7.70401H3.67193L5.35193 21.192C5.51993 22.464 6.59993 23.448 7.89593 23.448H16.0559C17.3519 23.448 18.4559 22.488 18.5999 21.192L20.2799 7.70401H20.9519C21.3119 7.70401 21.5999 7.41601 21.5999 7.05601V3.81601C21.6239 3.45601 21.3359 3.16801 20.9999 3.16801ZM10.0799 1.89601H13.9199V3.19201H10.0799V1.89601ZM17.3519 21C17.2799 21.648 16.7279 22.128 16.0799 22.128H7.91993C7.27193 22.128 6.71993 21.648 6.64793 21L4.99193 7.68001H19.0319L17.3519 21ZM20.3519 6.38401H3.64793V4.46401H20.3519V6.38401Z",
      fill: textPrimaryM
    }),
    /*#__PURE__*/
    React.createElement("path", {
      d: "M9.072 20.16C9.096 20.16 9.096 20.16 9.12 20.16C9.48 20.136 9.744 19.824 9.72 19.464L9.048 10.344C9.024 9.98401 8.712 9.72001 8.352 9.74401C7.992 9.76801 7.728 10.08 7.752 10.44L8.424 19.56C8.448 19.896 8.736 20.16 9.072 20.16Z",
      fill: textPrimaryM
    }),
    /*#__PURE__*/
    React.createElement("path", {
      d: "M11.9999 20.16C12.3599 20.16 12.6479 19.872 12.6479 19.512V10.392C12.6479 10.032 12.3599 9.74399 11.9999 9.74399C11.6399 9.74399 11.3519 10.032 11.3519 10.392V19.512C11.3519 19.872 11.6399 20.16 11.9999 20.16Z",
      fill: textPrimaryM
    }),
    /*#__PURE__*/
    React.createElement("path", {
      d: "M14.88 20.16C14.904 20.16 14.904 20.16 14.928 20.16C15.264 20.16 15.552 19.896 15.576 19.56L16.248 10.44C16.272 10.08 16.008 9.76801 15.648 9.74401C15.288 9.72001 14.976 9.98401 14.952 10.344L14.28 19.464C14.256 19.824 14.52 20.136 14.88 20.16Z",
      fill: textPrimaryM
    }))
  );
}

export default DeleteIcon;